import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl } from '@angular/forms';

export interface ValidationMessages {
  [key: string]: string;
}

const DEFAULT_MESSAGES: ValidationMessages = {
  required: 'Este campo é obrigatório.',
  email: 'Informe um e-mail válido.',
  minlength: 'Valor muito curto.',
  maxlength: 'Valor muito longo.',
  min: 'Valor abaixo do mínimo permitido.',
  max: 'Valor acima do máximo permitido.',
  pattern: 'Formato inválido.',
};

@Component({
  selector: 'is-form-error',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="shouldShow" class="invalid-feedback d-block">
      {{ errorMessage }}
    </div>
  `,
})
export class FormErrorComponent {
  @Input() control: AbstractControl | null = null;
  @Input() messages: ValidationMessages = {};

  get shouldShow(): boolean {
    return !!(this.control?.invalid && (this.control?.dirty || this.control?.touched));
  }

  get errorMessage(): string {
    const errors = this.control?.errors;
    if (!errors) return '';

    const allMessages = { ...DEFAULT_MESSAGES, ...this.messages };

    for (const key of Object.keys(errors)) {
      if (allMessages[key]) {
        const msg = allMessages[key];
        // Inject dynamic values for minlength/maxlength
        if (key === 'minlength') {
          return `Mínimo de ${errors[key].requiredLength} caracteres.`;
        }
        if (key === 'maxlength') {
          return `Máximo de ${errors[key].requiredLength} caracteres.`;
        }
        return msg;
      }
    }
    return 'Campo inválido.';
  }
}
